"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableRow = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../../foundation/Icons");

var _TableCell = _interopRequireDefault(require("./TableCell"));

var _TableContext = _interopRequireDefault(require("./TableContext"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TableRow = function TableRow(props) {
  var children = props.children,
      extraRows = props.extraRows,
      classNames = props.classNames,
      onClick = props.onClick,
      NewProps = _objectWithoutProperties(props, ["children", "extraRows", "classNames", "onClick"]);

  var _useContext = (0, _react.useContext)(_TableContext.default),
      tableHasExtraRows = _useContext.hasExtraRows;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1]; // if we received an onClick or extraRows prop, the row is clickable


  var isRowClickable = !_lodash.default.isUndefined(onClick) || !_lodash.default.isUndefined(extraRows);

  var handleClick = function handleClick() {
    var nextIsExpanded = !isExpanded;
    setIsExpanded(nextIsExpanded);

    if (!_lodash.default.isUndefined(onClick)) {
      onClick(nextIsExpanded);
    }
  }; // ADA compliant - allow an enter key to act like a click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var rowClassNames = {
    'table-row': !extraRows,
    collapsed: extraRows && !isExpanded,
    expanded: extraRows && isExpanded,
    'table-row-extra': extraRows,
    'table-row--clickable': isRowClickable
  };
  /**
   * Iterates through the "extra rows" and set isExtraRow prop on them
   * @param extraRows
   */

  var modifyExtraRows = function modifyExtraRows() {
    return _react.default.Children.map(_react.default.Children.toArray(extraRows), function (row) {
      return _react.default.cloneElement(row, {
        isExtraRow: true
      });
    });
  };

  var rowExtraParams = isRowClickable ? {
    onClick: handleClick,
    onKeyDown: _handleKeyPress,
    tabIndex: 0
  } : {};
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", _extends({
    className: (0, _classnames.default)(rowClassNames, classNames),
    role: isRowClickable ? 'button' : 'row'
  }, rowExtraParams, NewProps), extraRows && /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    classNames: "expand-control",
    key: "expand-control"
  }, isExpanded ? /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronDown, {
    flip: "vertical",
    className: "control-icon",
    size: "1x"
  }) : /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronDown, {
    className: "control-icon",
    size: "1x"
  })), !extraRows && tableHasExtraRows && /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    classNames: "expand-spacer",
    key: "expand-spacer"
  }), children), isExpanded && modifyExtraRows());
};

exports.TableRow = TableRow;
TableRow.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  onClick: _propTypes.default.func,
  extraRows: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
var defaultProps = {
  classNames: ''
};
TableRow.defaultProps = defaultProps;
var _default = TableRow;
exports.default = _default;